import { render, staticRenderFns } from "./stars.vue?vue&type=template&id=6bf4d89e"
import script from "./stars.vue?vue&type=script&lang=ts"
export * from "./stars.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports